import React, { useContext, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { useOnMount } from "../hooks/useOnMount";
const MobileOptimizedViewContext = /*#__PURE__*/React.createContext({
  setMobileViewportType: () => {}
});
const typeToContent = {
  standard: 'width=1280',
  optimized: 'width=device-width, initial-scale=1'
};

/** Controls the viewport width in mobile devices. */
export function MobileViewportWidthProvider(_ref) {
  let {
    children
  } = _ref;
  const [type, setType] = useState('standard');
  const value = useMemo(() => ({
    setMobileViewportType: setType
  }), []);
  return /*#__PURE__*/React.createElement(MobileOptimizedViewContext.Provider, {
    value: value
  }, /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: typeToContent[type],
    "data-testid": "viewport"
  }), document.head), children);
}

/**
 * When a page is wrapped by this higher-order component, it tells the mobile-browser that it's a mobile-optimized page
 * and the browser will enforce viewport width to be the device width.
 */
export function withOptimizedMobileViewport(Component) {
  return function WithOptimizedMobileViewport(props) {
    const {
      setMobileViewportType
    } = useContext(MobileOptimizedViewContext);
    useOnMount(() => {
      setMobileViewportType('optimized');
      return () => setMobileViewportType('standard');
    });
    return /*#__PURE__*/React.createElement(Component, props);
  };
}